import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { C, cardBase } from '../lib/design';
import { tg } from '../hooks/useTelegram';

const SYNE = { fontFamily: "'Syne', sans-serif" };

// ── Document content ─────────────────────────────────────────────────────────

const TERMS_SECTIONS = [
  {
    title: '1. Введение',
    body: 'Добро пожаловать в GeoEarn.\n\nНастоящие Условия ("Условия") регулируют ваш доступ и использование:\n\n• GeoEarn Telegram Bot\n• GeoEarn Mini App\n• Сайта GeoEarn и связанных сервисов\n\nИспользуя GeoEarn, вы соглашаетесь с настоящими Условиями. Если вы не согласны — вы должны прекратить использование платформы.',
  },
  {
    title: '2. Правомочность',
    body: 'Используя GeoEarn, вы подтверждаете, что:\n\n• соответствуете минимальному возрасту, требуемому в вашей юрисдикции\n• имеете право использовать Telegram-сервисы\n• предоставленная вами информация достоверна\n\nGeoEarn может ограничивать доступ в отдельных регионах.',
  },
  {
    title: '3. Аккаунты',
    body: 'Пользователи получают доступ через аутентификацию Telegram.\n\nВы несёте ответственность за:\n\n• сохранность доступа к своему аккаунту Telegram\n• защиту устройства и безопасность аккаунта\n• соответствие вашей деятельности настоящим Условиям\n\nЗапрещается:\n\n• создавать несколько аккаунтов для злоупотреблений\n• выдавать себя за других лиц\n• делиться аккаунтом для накрутки наград',
  },
  {
    title: '4. GEO-награды',
    body: 'GeoEarn начисляет GEO-монеты за участие в кампаниях и активностях.\n\nGEO-награды:\n\n• являются частью системы вознаграждений платформы\n• могут иметь изменяющийся курс конвертации\n• не являются инвестиционными продуктами, ценными бумагами или активами\n\nGeoEarn оставляет за собой право изменять суммы и правила начисления, приостанавливать кампании и отменять мошеннические награды.',
  },
  {
    title: '5. Выводы',
    body: 'Заявки на вывод могут:\n\n• проходить ручную проверку\n• быть задержаны для верификации\n• быть отклонены при подозрительной активности\n\nGeoEarn вправе ограничивать выводы, запрашивать дополнительную верификацию и приостанавливать выводы на время расследований. Сроки обработки могут варьироваться.',
  },
  {
    title: '6. Запрещённые действия',
    body: 'Запрещается:\n\n• подделывать GPS-координаты\n• злоупотреблять QR-системой\n• использовать автоматизацию, боты, скрипты или макросы\n• эксплуатировать баги или уязвимости\n• создавать мошеннические рефералы\n• манипулировать кампаниями\n• препятствовать работе платформы\n• пытаться получить несанкционированный доступ к системам\n\nНарушения могут повлечь отмену наград, блокировку аккаунта, перманентный бан или юридические меры.',
  },
  {
    title: '7. Бизнес-аккаунты',
    body: 'Бизнесы, использующие GeoEarn, несут ответственность за:\n\n• достоверность информации о кампаниях\n• законность акций и предложений\n• поддержание бюджета кампаний\n• соблюдение местного законодательства\n\nGeoEarn может удалять или приостанавливать кампании по своему усмотрению.',
  },
  {
    title: '8. Интеллектуальная собственность',
    body: 'Все брендинг, программное обеспечение, дизайн, системы и контент GeoEarn защищены законами об интеллектуальной собственности.\n\nЗапрещается копировать платформу, проводить реверс-инжиниринг или воспроизводить брендинг без разрешения.',
  },
  {
    title: '9. Доступность платформы',
    body: 'GeoEarn может обновлять платформу, изменять функции, временно приостанавливать работу или прекращать функции без предварительного уведомления. Мы не гарантируем бесперебойную работу.',
  },
  {
    title: '10. Ограничение ответственности',
    body: 'GeoEarn предоставляется «как есть» без каких-либо гарантий.\n\nМы не несём ответственности за:\n\n• технические сбои\n• потерю наград в ходе расследований\n• проблемы со сторонними платёжными системами\n• изменения бизнес-кампаний\n• косвенный или последующий ущерб\n\nПользователи используют платформу на свой страх и риск.',
  },
  {
    title: '11. Блокировка аккаунта',
    body: 'GeoEarn вправе приостановить аккаунт, удалить награды, прекратить доступ или заблокировать пользователя без предварительного уведомления при обнаружении нарушений.',
  },
  {
    title: '12. Конфиденциальность',
    body: 'Использование GeoEarn также регулируется Политикой конфиденциальности. Используя платформу, вы соглашаетесь со сбором и использованием данных, описанным в Политике.',
  },
  {
    title: '13. Изменение условий',
    body: 'GeoEarn может обновлять настоящие Условия в любое время. Актуальные версии публикуются через официальные каналы. Продолжение использования платформы означает принятие обновлённых Условий.',
  },
  {
    title: '14. Контакт',
    body: 'По вопросам поддержки и юридическим запросам:\n\nGeoEarn Support\nTelegram: @geoearn',
  },
];

const PRIVACY_SECTIONS = [
  {
    title: '1. Введение',
    body: 'GeoEarn уважает вашу конфиденциальность и стремится защитить ваши персональные данные.\n\nНастоящая Политика конфиденциальности объясняет, какие данные мы собираем, как используем и какие права у вас есть при использовании:\n\n• GeoEarn Telegram Bot\n• GeoEarn Mini App\n• Сайта GeoEarn и связанных сервисов\n\nИспользуя GeoEarn, вы соглашаетесь с настоящей Политикой.',
  },
  {
    title: '2. Собираемые данные',
    body: 'Мы можем собирать следующую информацию:\n\n📱 Telegram: Telegram ID, имя пользователя, имя, данные профиля.\n\n📍 Геолокация: GPS при чекинах, примерное местоположение для кампаний.\n\n📊 Данные использования: взаимодействия с приложением, история чекинов и наград, реферальная активность, информация об устройстве/браузере, IP-адрес.\n\n💳 Финансовые данные: заявки на вывод, номер банковской карты (Humo / Uzcard), балансы.',
  },
  {
    title: '3. Использование данных',
    body: 'Мы используем данные для:\n\n• предоставления сервисов GeoEarn\n• обработки наград и выводов\n• верификации чекинов по геолокации\n• предотвращения мошенничества\n• улучшения платформы\n• персонализации кампаний\n• отправки важных уведомлений\n• обеспечения безопасности платформы',
  },
  {
    title: '4. Антифрод',
    body: 'GeoEarn использует антифрод-системы для защиты бизнесов и пользователей.\n\nМы можем анализировать активность устройства, паттерны чекинов, согласованность геолокации, реферальное поведение и признаки подозрительной активности.\n\nАккаунты, нарушающие правила платформы, могут быть заблокированы.',
  },
  {
    title: '5. Передача данных',
    body: 'Мы не продаём персональные данные.\n\nМы можем передавать ограниченную информацию:\n\n• платёжным провайдерам\n• провайдерам инфраструктуры\n• аналитическим сервисам\n• государственным органам в случаях, предусмотренных законом\n\nПартнёры-бизнесы не получают ваши контактные данные без явного согласия.',
  },
  {
    title: '6. Хранение и безопасность',
    body: 'Мы применяем отраслевые стандарты безопасности для защиты данных. Тем не менее ни одна система не может гарантировать абсолютную безопасность. Данные могут храниться на защищённых облачных серверах.',
  },
  {
    title: '7. Cookies и аналитика',
    body: 'GeoEarn может использовать cookies, локальное хранилище, аналитические и мониторинговые инструменты для улучшения пользовательского опыта и стабильности платформы.',
  },
  {
    title: '8. Ваши права',
    body: 'Вы можете запросить:\n\n• доступ к своим данным\n• исправление неточных данных\n• удаление аккаунта\n• удаление персональной информации\n\nДля запроса на удаление аккаунта обратитесь в поддержку GeoEarn.',
  },
  {
    title: '9. Данные несовершеннолетних',
    body: 'GeoEarn не предназначен для пользователей, не достигших минимального возраста согласно местному законодательству. Используя платформу, вы подтверждаете соответствие возрастным требованиям.',
  },
  {
    title: '10. Изменения Политики',
    body: 'Мы можем обновлять настоящую Политику конфиденциальности. Актуальные версии публикуются на официальных платформах GeoEarn.',
  },
  {
    title: '11. Контакт',
    body: 'По вопросам конфиденциальности:\n\nGeoEarn Support\nTelegram: @geoearn',
  },
];

// ── Shared component ──────────────────────────────────────────────────────────

export function LegalSheet({ initialTab = 'terms', onClose }) {
  const [tab, setTab] = useState(initialTab);

  const sections = tab === 'terms' ? TERMS_SECTIONS : PRIVACY_SECTIONS;
  const updated = 'Май 2026';

  useEffect(() => {
    if (tg?.BackButton) {
      tg.BackButton.show();
      tg.BackButton.onClick(onClose);
      return () => {
        tg.BackButton.hide();
        tg.BackButton.offClick(onClose);
      };
    }
  }, [onClose]);

  return (
    <div style={{
      minHeight: '100vh',
      background: C.bg,
      display: 'flex', flexDirection: 'column',
      overflowY: 'auto',
    }}>
      {/* Header */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 10,
        background: 'rgba(9,11,16,0.96)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderBottom: `0.5px solid ${C.b1}`,
        padding: '16px 20px 0',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', cursor: 'pointer', padding: 4,
              color: C.t2, display: 'flex', alignItems: 'center',
              WebkitTapHighlightColor: 'transparent',
            }}
          >
            <ArrowLeft size={22} strokeWidth={2} />
          </button>
          <div style={{ ...SYNE, fontSize: 18, fontWeight: 700, color: C.t1 }}>
            Юридические документы
          </div>
        </div>

        {/* Tab switcher */}
        <div style={{
          display: 'flex', gap: 0,
          background: C.surf,
          borderRadius: 12, padding: 4,
          marginBottom: 0,
        }}>
          {[
            { key: 'terms',   label: 'Условия' },
            { key: 'privacy', label: 'Конфиденциальность' },
          ].map(t => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              style={{
                flex: 1, border: 'none', cursor: 'pointer',
                borderRadius: 9, padding: '9px 12px',
                fontSize: 13, fontWeight: 700,
                background: tab === t.key ? C.card : 'transparent',
                color: tab === t.key ? C.t1 : C.t3,
                transition: 'all 0.18s ease',
                WebkitTapHighlightColor: 'transparent',
              }}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: '20px 20px 40px', display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ fontSize: 12, color: C.t3, marginBottom: 4 }}>
          Последнее обновление: {updated}
        </div>

        {sections.map((s, i) => (
          <div key={i} style={{
            ...cardBase,
            padding: '18px 20px',
          }}>
            <div style={{
              ...SYNE, fontSize: 14, fontWeight: 700,
              color: C.t1, marginBottom: 10,
            }}>
              {s.title}
            </div>
            <div style={{
              fontSize: 13, color: C.t2, lineHeight: 1.7,
              whiteSpace: 'pre-wrap',
            }}>
              {s.body}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Route page ────────────────────────────────────────────────────────────────

export default function Legal() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const tab = params.get('tab') === 'privacy' ? 'privacy' : 'terms';
  return <LegalSheet initialTab={tab} onClose={() => navigate(-1)} />;
}
